import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var MicrophoneOnIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M14 5v6a2 2 0 11-4 0V5a2 2 0 114 0zM8 5a4 4 0 118 0v6a4 4 0 01-8 0V5zm-2.072 6.01a1 1 0 011.131.849C7.411 14.32 9.292 16 12 16c2.708 0 4.59-1.679 4.941-4.141a1 1 0 011.98.282c-.45 3.155-2.755 5.406-5.92 5.798V21h3a1 1 0 110 2H8a1 1 0 110-2h3v-3.06c-3.165-.392-5.47-2.644-5.92-5.799a1 1 0 01.848-1.131z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
MicrophoneOnIcon.isCarinaIcon = true;
export default MicrophoneOnIcon;
